import { message, PageHeader, Popconfirm, Tag, Tooltip } from "antd";
import axios from "axios";
import React, { Component } from "react";
import {
  TableItemDinamico,
  dineroDisabledMask,
  ButtonItem,
  SegmentedItem,
} from "../../../Components/Items";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { CloseCircleOutlined, EyeOutlined, FilePdfOutlined } from "@ant-design/icons";
import MandarCorreoProrrateo from "./MandarCorreoProrrateo/MandarCorreoProrrateo";

moment.locale("es");

class Prorrateos extends Component {
  tableRef = null;
  state = {
    loading: false,
    todosProrrateos: [],
    totalRecords: 0,
    valor: 5,
    modalCorreo: false,
    modalCorreoId: null,
  };

  consultarProrrateos(params = {}) {
    this.setState({ loading: true });
    const body = {
      empresaId: this.props.empresaId,
      ...params,
    };
    axios
      .post("prorrateo/selectProrrateos", body, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          this.setState({
            todosProrrateos: res.data.data,
            totalRecords: res.data.totalRecords,
          });
        } else {
          message.error("Error al cargar prorrateos");
        }
      });
  }

  cancelarProrrateo(record) {
    this.setState({ loading: true });
    axios
      .post(
        "prorrateo/cancelarProrrateo",
        { empresaId: this.props.empresaId, prorrateoId: record._id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(res.data.message);
          if (this.tableRef) this.tableRef.updateExternalFilters({ valor: this.state.valor });
        } else if (res.data.success === 1) {
          message.warn(res.data.message);
        } else {
          message.error(res.data.message || "Error al cancelar prorrateo");
        }
      });
  }

  render() {
    const { loading, todosProrrateos, totalRecords } = this.state;

    const tipoTag = (tipo) => {
      if (tipo === "facturaCompleta") return <Tag color="purple">Factura Completa</Tag>;
      if (tipo === "insumoFactura") return <Tag color="cyan">Insumo Factura</Tag>;
      if (tipo === "insumoCompleto") return <Tag color="geekblue">Insumo Completo</Tag>;
      return <Tag>{tipo}</Tag>;
    };

    const columns = [
      { title: "Folio", dataIndex: "folio", key: "folio", width: "6%" },
      {
        title: "Tipo",
        dataIndex: "tipo",
        key: "tipo",
        width: "14%",
        render: (tipo) => tipoTag(tipo),
      },
      {
        title: "Método",
        dataIndex: "metodo",
        key: "metodo",
        width: "8%",
        render: (metodo, record) => (record.tipo === "facturaCompleta" ? metodo : "—"),
      },
      {
        title: "Factura origen",
        dataIndex: "facturaOrigen",
        key: "facturaOrigen",
        width: "12%",
        render: (v) => v?.codigoFactura,
      },
      {
        title: "Objetivo",
        key: "objetivo",
        width: "12%",
        render: (_, record) =>
          record.tipoObjetivo === "ordenDeCompra"
            ? [record.ordenDeCompraObjetivo?.serieOrdenCompra, record.ordenDeCompraObjetivo?.numero]
                .filter(Boolean)
                .join(" ")
            : record.facturaObjetivo?.codigoFactura,
      },
      {
        title: "Proyecto",
        dataIndex: "proyecto",
        key: "proyecto",
        width: "15%",
        ellipsis: true,
        render: (v) => v?.nombre,
      },
      {
        title: "Monto",
        dataIndex: "montoProrrateo",
        key: "montoProrrateo",
        width: "10%",
        align: "right",
        render: (v) => dineroDisabledMask(v),
      },
      {
        title: "Fecha",
        dataIndex: "fechaRegistro",
        key: "fechaRegistro",
        width: "10%",
        render: (v) => moment(v).format("L"),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        width: "8%",
        render: (estado) =>
          estado === 1 ? <Tag color="green">Activo</Tag> : <Tag color="red">Cancelado</Tag>,
      },
      {
        title: "Acción",
        key: "accion",
        width: "12%",
        render: (_, value) => (
          <div style={{ display: "flex", gap: 4 }}>
            <Tooltip
              title="Ver prorrateo"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                type="default"
                size="small"
                azul
                icon={<EyeOutlined />}
                onClick={() => this.props.history.push("/panel/verProrrateo", { id: value._id })}
              />
            </Tooltip>
            <Tooltip
              title="Ver PDF"
              placement="top"
              overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
            >
              <ButtonItem
                type="default"
                size="small"
                icon={<FilePdfOutlined />}
                onClick={() => this.setState({ modalCorreo: true, modalCorreoId: value._id })}
              />
            </Tooltip>
            <Popconfirm
              title="¿Seguro que quieres cancelar este prorrateo?"
              onConfirm={() => this.cancelarProrrateo(value)}
              okText="Sí"
              cancelText="No"
              disabled={value.estado !== 1}
            >
              <Tooltip
                title="Cancelar"
                placement="top"
                overlayInnerStyle={{ fontSize: "10px", padding: "1px 5px", minHeight: "auto" }}
              >
                <ButtonItem
                  type="default"
                  size="small"
                  danger
                  disabled={value.estado !== 1}
                  icon={<CloseCircleOutlined />}
                />
              </Tooltip>
            </Popconfirm>
          </div>
        ),
      },
    ];

    const { modalCorreo, modalCorreoId } = this.state;

    return (
      <>
        <MandarCorreoProrrateo
          visible={modalCorreo}
          id={modalCorreoId}
          cerrarMandarCorreoProrrateo={() => this.setState({ modalCorreo: false, modalCorreoId: null })}
        />
        <PageHeader
          title="Prorrateos"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <SegmentedItem
              options={[
                { label: "Activos", value: 1 },
                { label: "Cancelados", value: 2 },
                { label: "Todos", value: 5 },
              ]}
              onChange={(value) => {
                if (this.tableRef) {
                  this.tableRef.updateExternalFilters({ valor: value });
                }
                this.setState({ valor: value });
              }}
              value={this.state.valor}
            />
          }
        />
        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          anadirValorFiltro={this.state.valor}
          onFetchData={this.consultarProrrateos.bind(this)}
          size="small"
          dataSource={todosProrrateos}
          columns={columns}
          pagination={false}
          filterStorageKey={"prorrateosFiltros" + this.props.empresaId}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Prorrateos);
